import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import ellipsis from 'polished/lib/mixins/ellipsis'
import { mobileCSS } from '@measures/responsive'
import TeamLogo from './TeamLogo'

interface TeamCellProps {
  teamLogoSrc: string
  teamName: string
}

const StyledTeamCell = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-auto-flow: column;
  align-items: center;
  grid-column-gap: 10px;
  width: 100%;
  min-height: 46px;
`

const StyledTeamName = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_90 },
      },
      fonts: { sourceSansPro },
    },
  }) => {
    return css`
      font-family: ${sourceSansPro};
      font-size: 17px;
      line-height: 1.2;
      font-weight: bold;
      color: ${grey_90};
      letter-spacing: 0.01em;
      ${ellipsis('100%', 2)};

      ${mobileCSS(css`
        font-size: 14px;
      `)}
    `
  }}
`

const TeamCell: FunctionComponent<TeamCellProps> = ({
  teamLogoSrc,
  teamName,
}) => {
  return (
    <StyledTeamCell>
      <TeamLogo url={teamLogoSrc} name={teamName} />
      <StyledTeamName>{teamName}</StyledTeamName>
    </StyledTeamCell>
  )
}

export default TeamCell
